angular.module('jv.requisition.lijobpostingstatus.controller', [])
    .controller('ReqsLiJobPostingStatusCtrl', ['$scope', 'Reqs',
        function ($scope, Reqs) {

            $scope.jobStatusList = {};
            $scope.isActive = [];
            $scope.showNoResults= false;
            $scope.fetchLiJobPostingStatus = function () {
                var data = {
                    'reqEId': $scope.params.id,
                    'resync': 'false'
                };
                Reqs.getLinkedInAcJobPostStatus(data, function (response) {
                    $scope.jobStatusList = response;
                    $scope.flags.loading = false;
                    $scope.showNoResults = Object.keys($scope.jobStatusList).length === 0 ? true : false;
                });
            };

            $scope.resyncLiJobPostingStatus = function () {
                var data = {
                    'reqEId': $scope.params.id,
                    'resync': 'true'
                };
                Reqs.getLinkedInAcJobPostStatus(data, function (response) {
                    $scope.jobStatusList = response;
                });
            };

            if ($scope.$parent.tabClicked === 'lijobstatus' && !$.isEmptyObject($scope.params) && typeof $scope.params.id !== 'undefined') {
                $scope.fetchLiJobPostingStatus();
            } else if ($scope.activeTab('#/lijobstatus')) {
                var options = angular.extend({
                    paginated: $scope.flags.paginated
                }, $scope.params);
                if (!$.isEmptyObject($scope.params)) {
                    Reqs.details(options, function (requisition) {
                        angular.extend($scope.requisitions, requisition);
                        if ($scope.requisitions.forumBaseUrl) {
                            $scope.$root.forumBaseUrl = $scope.requisitions.forumBaseUrl;
                        }
                        $scope.params.id = $scope.requisitions.jobDetails.EId;
                        $scope.fetchLiJobPostingStatus();
                    });
                }
            }
            $scope.toggleAccordion = function (index) {
                $scope.isActive[index] = !$scope.isActive[index];
            };
            
            $scope.isEmpty = function(obj) {
                return !obj || Object.keys(obj).length === 0;
            };
        }
    ]);
